var __create = Object.create;
var __defProp = Object.defineProperty,
  __defProps = Object.defineProperties,
  __getOwnPropDesc = Object.getOwnPropertyDescriptor,
  __getOwnPropDescs = Object.getOwnPropertyDescriptors,
  __getOwnPropNames = Object.getOwnPropertyNames,
  __getOwnPropSymbols = Object.getOwnPropertySymbols,
  __getProtoOf = Object.getPrototypeOf,
  __hasOwnProp = Object.prototype.hasOwnProperty,
  __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value
  }) : obj[key] = value,
  __spreadValues = (a, b) => {
    for (var prop in b || (b = {})) __hasOwnProp.call(b, prop) && __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) __propIsEnum.call(b, prop) && __defNormalProp(a, prop, b[prop]);
    return a;
  },
  __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __commonJS = (cb, mod) => function () {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = {
    exports: {}
  }).exports, mod), mod.exports;
};
var __copyProps = (to, from2, except, desc) => {
  if (from2 && typeof from2 == "object" || typeof from2 == "function") for (let key of __getOwnPropNames(from2)) !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, {
    get: () => from2[key],
    enumerable: !(desc = __getOwnPropDesc(from2, key)) || desc.enumerable
  });
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
  value: mod,
  enumerable: !0
}) : target, mod));
var require_extends = __commonJS({
  "../../../node_modules/@babel/runtime/helpers/extends.js"(exports, module) {
    function _extends3() {
      return module.exports = _extends3 = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
        }
        return target;
      }, module.exports.__esModule = !0, module.exports.default = module.exports, _extends3.apply(this, arguments);
    }
    module.exports = _extends3, module.exports.__esModule = !0, module.exports.default = module.exports;
  }
});
var require_react_is_production_min = __commonJS({
  "../../../node_modules/react-is/cjs/react-is.production.min.js"(exports) {
    "use strict";

    var b = typeof Symbol == "function" && Symbol.for,
      c = b ? Symbol.for("react.element") : 60103,
      d = b ? Symbol.for("react.portal") : 60106,
      e = b ? Symbol.for("react.fragment") : 60107,
      f = b ? Symbol.for("react.strict_mode") : 60108,
      g = b ? Symbol.for("react.profiler") : 60114,
      h = b ? Symbol.for("react.provider") : 60109,
      k = b ? Symbol.for("react.context") : 60110,
      l = b ? Symbol.for("react.async_mode") : 60111,
      m = b ? Symbol.for("react.concurrent_mode") : 60111,
      n = b ? Symbol.for("react.forward_ref") : 60112,
      p = b ? Symbol.for("react.suspense") : 60113,
      q = b ? Symbol.for("react.suspense_list") : 60120,
      r = b ? Symbol.for("react.memo") : 60115,
      t = b ? Symbol.for("react.lazy") : 60116,
      v = b ? Symbol.for("react.block") : 60121,
      w = b ? Symbol.for("react.fundamental") : 60117,
      x = b ? Symbol.for("react.responder") : 60118,
      y = b ? Symbol.for("react.scope") : 60119;
    function z(a) {
      if (typeof a == "object" && a !== null) {
        var u = a.$$typeof;
        switch (u) {
          case c:
            switch (a = a.type, a) {
              case l:
              case m:
              case e:
              case g:
              case f:
              case p:
                return a;
              default:
                switch (a = a && a.$$typeof, a) {
                  case k:
                  case n:
                  case t:
                  case r:
                  case h:
                    return a;
                  default:
                    return u;
                }
            }
          case d:
            return u;
        }
      }
    }
    function A(a) {
      return z(a) === m;
    }
    exports.AsyncMode = l;
    exports.ConcurrentMode = m;
    exports.ContextConsumer = k;
    exports.ContextProvider = h;
    exports.Element = c;
    exports.ForwardRef = n;
    exports.Fragment = e;
    exports.Lazy = t;
    exports.Memo = r;
    exports.Portal = d;
    exports.Profiler = g;
    exports.StrictMode = f;
    exports.Suspense = p;
    exports.isAsyncMode = function (a) {
      return A(a) || z(a) === l;
    };
    exports.isConcurrentMode = A;
    exports.isContextConsumer = function (a) {
      return z(a) === k;
    };
    exports.isContextProvider = function (a) {
      return z(a) === h;
    };
    exports.isElement = function (a) {
      return typeof a == "object" && a !== null && a.$$typeof === c;
    };
    exports.isForwardRef = function (a) {
      return z(a) === n;
    };
    exports.isFragment = function (a) {
      return z(a) === e;
    };
    exports.isLazy = function (a) {
      return z(a) === t;
    };
    exports.isMemo = function (a) {
      return z(a) === r;
    };
    exports.isPortal = function (a) {
      return z(a) === d;
    };
    exports.isProfiler = function (a) {
      return z(a) === g;
    };
    exports.isStrictMode = function (a) {
      return z(a) === f;
    };
    exports.isSuspense = function (a) {
      return z(a) === p;
    };
    exports.isValidElementType = function (a) {
      return typeof a == "string" || typeof a == "function" || a === e || a === m || a === g || a === f || a === p || a === q || typeof a == "object" && a !== null && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
    };
    exports.typeOf = z;
  }
});
var require_react_is = __commonJS({
  "../../../node_modules/react-is/index.js"(exports, module) {
    "use strict";

    module.exports = require_react_is_production_min();
  }
});
var require_hoist_non_react_statics_cjs = __commonJS({
  "../../../node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js"(exports, module) {
    "use strict";

    var reactIs = require_react_is(),
      REACT_STATICS = {
        childContextTypes: !0,
        contextType: !0,
        contextTypes: !0,
        defaultProps: !0,
        displayName: !0,
        getDefaultProps: !0,
        getDerivedStateFromError: !0,
        getDerivedStateFromProps: !0,
        mixins: !0,
        propTypes: !0,
        type: !0
      },
      KNOWN_STATICS = {
        name: !0,
        length: !0,
        prototype: !0,
        caller: !0,
        callee: !0,
        arguments: !0,
        arity: !0
      },
      FORWARD_REF_STATICS = {
        $$typeof: !0,
        render: !0,
        defaultProps: !0,
        displayName: !0,
        propTypes: !0
      },
      MEMO_STATICS = {
        $$typeof: !0,
        compare: !0,
        defaultProps: !0,
        displayName: !0,
        propTypes: !0,
        type: !0
      },
      TYPE_STATICS = {};
    TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
    TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
    function getStatics(component) {
      return reactIs.isMemo(component) ? MEMO_STATICS : TYPE_STATICS[component.$$typeof] || REACT_STATICS;
    }
    var defineProperty = Object.defineProperty,
      getOwnPropertyNames = Object.getOwnPropertyNames,
      getOwnPropertySymbols = Object.getOwnPropertySymbols,
      getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor,
      getPrototypeOf = Object.getPrototypeOf,
      objectPrototype = Object.prototype;
    function hoistNonReactStatics2(targetComponent, sourceComponent, blacklist) {
      if (typeof sourceComponent != "string") {
        if (objectPrototype) {
          var inheritedComponent = getPrototypeOf(sourceComponent);
          inheritedComponent && inheritedComponent !== objectPrototype && hoistNonReactStatics2(targetComponent, inheritedComponent, blacklist);
        }
        var keys = getOwnPropertyNames(sourceComponent);
        getOwnPropertySymbols && (keys = keys.concat(getOwnPropertySymbols(sourceComponent)));
        for (var targetStatics = getStatics(targetComponent), sourceStatics = getStatics(sourceComponent), i = 0; i < keys.length; ++i) {
          var key = keys[i];
          if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
            var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
            try {
              defineProperty(targetComponent, key, descriptor);
            } catch (e) {}
          }
        }
      }
      return targetComponent;
    }
    module.exports = hoistNonReactStatics2;
  }
});
var require_object_assign = __commonJS({
  "../../../node_modules/object-assign/index.js"(exports, module) {
    "use strict";

    var getOwnPropertySymbols = Object.getOwnPropertySymbols,
      hasOwnProperty2 = Object.prototype.hasOwnProperty,
      propIsEnumerable = Object.prototype.propertyIsEnumerable;
    function toObject(val) {
      if (val == null) throw new TypeError("Object.assign cannot be called with null or undefined");
      return Object(val);
    }
    function shouldUseNative() {
      try {
        if (!Object.assign) return !1;
        var test1 = new String("abc");
        if (test1[5] = "de", Object.getOwnPropertyNames(test1)[0] === "5") return !1;
        for (var test2 = {}, i = 0; i < 10; i++) test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
          return test2[n];
        });
        if (order2.join("") !== "0123456789") return !1;
        var test3 = {};
        return "abcdefghijklmnopqrst".split("").forEach(function (letter) {
          test3[letter] = letter;
        }), Object.keys(Object.assign({}, test3)).join("") === "abcdefghijklmnopqrst";
      } catch (err) {
        return !1;
      }
    }
    module.exports = shouldUseNative() ? Object.assign : function (target, source) {
      for (var from2, to = toObject(target), symbols, s = 1; s < arguments.length; s++) {
        from2 = Object(arguments[s]);
        for (var key in from2) hasOwnProperty2.call(from2, key) && (to[key] = from2[key]);
        if (getOwnPropertySymbols) {
          symbols = getOwnPropertySymbols(from2);
          for (var i = 0; i < symbols.length; i++) propIsEnumerable.call(from2, symbols[i]) && (to[symbols[i]] = from2[symbols[i]]);
        }
      }
      return to;
    };
  }
});
var import_extends4 = __toESM(require_extends());
import "react";
function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    return cache[arg] === void 0 && (cache[arg] = fn(arg)), cache[arg];
  };
}
var emotion_memoize_esm_default = memoize;
var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/,
  isPropValid = emotion_memoize_esm_default(function (prop) {
    return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
  }),
  emotion_is_prop_valid_esm_default = isPropValid;
function _extends() {
  return _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
    return target;
  }, _extends.apply(this, arguments);
}
import { useContext as useContext3, createElement as createElement3, Fragment as Fragment3 } from "react";
import { createElement as createElement2, useContext as useContext2, useRef, useLayoutEffect, Fragment as Fragment2 } from "react";
function sheetForTag(tag) {
  if (tag.sheet) return tag.sheet;
  for (var i = 0; i < document.styleSheets.length; i++) if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
}
function createStyleElement(options) {
  var tag = document.createElement("style");
  return tag.setAttribute("data-emotion", options.key), options.nonce !== void 0 && tag.setAttribute("nonce", options.nonce), tag.appendChild(document.createTextNode("")), tag.setAttribute("data-s", ""), tag;
}
var StyleSheet = function () {
  function StyleSheet2(options) {
    var _this = this;
    this._insertTag = function (tag) {
      var before;
      _this.tags.length === 0 ? _this.insertionPoint ? before = _this.insertionPoint.nextSibling : _this.prepend ? before = _this.container.firstChild : before = _this.before : before = _this.tags[_this.tags.length - 1].nextSibling, _this.container.insertBefore(tag, before), _this.tags.push(tag);
    }, this.isSpeedy = options.speedy === void 0 ? !0 : options.speedy, this.tags = [], this.ctr = 0, this.nonce = options.nonce, this.key = options.key, this.container = options.container, this.prepend = options.prepend, this.insertionPoint = options.insertionPoint, this.before = null;
  }
  var _proto = StyleSheet2.prototype;
  return _proto.hydrate = function (nodes) {
    nodes.forEach(this._insertTag);
  }, _proto.insert = function (rule) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(createStyleElement(this));
    var tag = this.tags[this.tags.length - 1];
    if (!1) var isImportRule;
    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);
      try {
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {}
    } else tag.appendChild(document.createTextNode(rule));
    this.ctr++;
  }, _proto.flush = function () {
    this.tags.forEach(function (tag) {
      return tag.parentNode && tag.parentNode.removeChild(tag);
    }), this.tags = [], this.ctr = 0;
  }, StyleSheet2;
}();
var MS = "-ms-",
  MOZ = "-moz-",
  WEBKIT = "-webkit-",
  COMMENT = "comm",
  RULESET = "rule",
  DECLARATION = "decl";
var IMPORT = "@import";
var KEYFRAMES = "@keyframes";
var abs = Math.abs,
  from = String.fromCharCode,
  assign = Object.assign;
function hash(value, length2) {
  return (((length2 << 2 ^ charat(value, 0)) << 2 ^ charat(value, 1)) << 2 ^ charat(value, 2)) << 2 ^ charat(value, 3);
}
function trim(value) {
  return value.trim();
}
function match(value, pattern) {
  return (value = pattern.exec(value)) ? value[0] : value;
}
function replace(value, pattern, replacement) {
  return value.replace(pattern, replacement);
}
function indexof(value, search) {
  return value.indexOf(search);
}
function charat(value, index2) {
  return value.charCodeAt(index2) | 0;
}
function substr(value, begin, end) {
  return value.slice(begin, end);
}
function strlen(value) {
  return value.length;
}
function sizeof(value) {
  return value.length;
}
function append(value, array) {
  return array.push(value), value;
}
function combine(array, callback) {
  return array.map(callback).join("");
}
var line = 1,
  column = 1,
  length = 0,
  position = 0,
  character = 0,
  characters = "";
function node(value, root, parent, type, props2, children, length2) {
  return {
    value,
    root,
    parent,
    type,
    props: props2,
    children,
    line,
    column,
    length: length2,
    return: ""
  };
}
function copy(root, props2) {
  return assign(node("", null, null, "", null, null, 0), root, {
    length: -root.length
  }, props2);
}
function char() {
  return character;
}
function prev() {
  return character = position > 0 ? charat(characters, --position) : 0, column--, character === 10 && (column = 1, line--), character;
}
function next() {
  return character = position < length ? charat(characters, position++) : 0, column++, character === 10 && (column = 1, line++), character;
}
function peek() {
  return charat(characters, position);
}
function caret() {
  return position;
}
function slice(begin, end) {
  return substr(characters, begin, end);
}
function token(type) {
  switch (type) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function alloc(value) {
  return line = column = 1, length = strlen(characters = value), position = 0, [];
}
function dealloc(value) {
  return characters = "", value;
}
function delimit(type) {
  return trim(slice(position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}
function whitespace(type) {
  for (; (character = peek()) && character < 33;) next();
  return token(type) > 2 || token(character) > 3 ? "" : " ";
}
function escaping(index2, count) {
  for (; --count && next() && !(character < 48 || character > 102 || character > 57 && character < 65 || character > 70 && character < 97););
  return slice(index2, caret() + (count < 6 && peek() == 32 && next() == 32));
}
function delimiter(type) {
  for (; next();) switch (character) {
    case type:
      return position;
    case 34:
    case 39:
      type !== 34 && type !== 39 && delimiter(character);
      break;
    case 40:
      type === 41 && delimiter(type);
      break;
    case 92:
      next();
      break;
  }
  return position;
}
function commenter(type, index2) {
  for (; next() && type + character !== 47 + 10;) if (type + character === 42 + 42 && peek() === 47) break;
  return "/*" + slice(index2, position - 1) + "*" + from(type === 47 ? type : next());
}
function identifier(index2) {
  for (; !token(peek());) next();
  return slice(index2, position);
}
function compile(value) {
  return dealloc(parse("", null, null, null, [""], value = alloc(value), 0, [0], value));
}
function parse(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
  for (var index2 = 0, offset = 0, length2 = pseudo, atrule = 0, property = 0, previous = 0, variable = 1, scanning = 1, ampersand = 1, character2 = 0, type = "", props2 = rules, children = rulesets, reference = rule, characters2 = type; scanning;) switch (previous = character2, character2 = next()) {
    case 40:
      if (previous != 108 && characters2.charCodeAt(length2 - 1) == 58) {
        indexof(characters2 += replace(delimit(character2), "&", "&\f"), "&\f") != -1 && (ampersand = -1);
        break;
      }
    case 34:
    case 39:
    case 91:
      characters2 += delimit(character2);
      break;
    case 9:
    case 10:
    case 13:
    case 32:
      characters2 += whitespace(previous);
      break;
    case 92:
      characters2 += escaping(caret() - 1, 7);
      continue;
    case 47:
      switch (peek()) {
        case 42:
        case 47:
          append(comment(commenter(next(), caret()), root, parent), declarations);
          break;
        default:
          characters2 += "/";
      }
      break;
    case 123 * variable:
      points[index2++] = strlen(characters2) * ampersand;
    case 125 * variable:
    case 59:
    case 0:
      switch (character2) {
        case 0:
        case 125:
          scanning = 0;
        case 59 + offset:
          property > 0 && strlen(characters2) - length2 && append(property > 32 ? declaration(characters2 + ";", rule, parent, length2 - 1) : declaration(replace(characters2, " ", "") + ";", rule, parent, length2 - 2), declarations);
          break;
        case 59:
          characters2 += ";";
        default:
          if (append(reference = ruleset(characters2, root, parent, index2, offset, rules, points, type, props2 = [], children = [], length2), rulesets), character2 === 123) if (offset === 0) parse(characters2, root, reference, reference, props2, rulesets, length2, points, children);else switch (atrule) {
            case 100:
            case 109:
            case 115:
              parse(value, reference, reference, rule && append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props2 = [], length2), children), rules, children, length2, points, rule ? props2 : children);
              break;
            default:
              parse(characters2, reference, reference, reference, [""], children, 0, points, children);
          }
      }
      index2 = offset = property = 0, variable = ampersand = 1, type = characters2 = "", length2 = pseudo;
      break;
    case 58:
      length2 = 1 + strlen(characters2), property = previous;
    default:
      if (variable < 1) {
        if (character2 == 123) --variable;else if (character2 == 125 && variable++ == 0 && prev() == 125) continue;
      }
      switch (characters2 += from(character2), character2 * variable) {
        case 38:
          ampersand = offset > 0 ? 1 : (characters2 += "\f", -1);
          break;
        case 44:
          points[index2++] = (strlen(characters2) - 1) * ampersand, ampersand = 1;
          break;
        case 64:
          peek() === 45 && (characters2 += delimit(next())), atrule = peek(), offset = length2 = strlen(type = characters2 += identifier(caret())), character2++;
          break;
        case 45:
          previous === 45 && strlen(characters2) == 2 && (variable = 0);
      }
  }
  return rulesets;
}
function ruleset(value, root, parent, index2, offset, rules, points, type, props2, children, length2) {
  for (var post = offset - 1, rule = offset === 0 ? rules : [""], size2 = sizeof(rule), i = 0, j = 0, k = 0; i < index2; ++i) for (var x = 0, y = substr(value, post + 1, post = abs(j = points[i])), z = value; x < size2; ++x) (z = trim(j > 0 ? rule[x] + " " + y : replace(y, /&\f/g, rule[x]))) && (props2[k++] = z);
  return node(value, root, parent, offset === 0 ? RULESET : type, props2, children, length2);
}
function comment(value, root, parent) {
  return node(value, root, parent, COMMENT, from(char()), substr(value, 2, -2), 0);
}
function declaration(value, root, parent, length2) {
  return node(value, root, parent, DECLARATION, substr(value, 0, length2), substr(value, length2 + 1, -1), length2);
}
function prefix(value, length2) {
  switch (hash(value, length2)) {
    case 5103:
      return WEBKIT + "print-" + value + value;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return WEBKIT + value + value;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return WEBKIT + value + MOZ + value + MS + value + value;
    case 6828:
    case 4268:
      return WEBKIT + value + MS + value + value;
    case 6165:
      return WEBKIT + value + MS + "flex-" + value + value;
    case 5187:
      return WEBKIT + value + replace(value, /(\w+).+(:[^]+)/, WEBKIT + "box-$1$2" + MS + "flex-$1$2") + value;
    case 5443:
      return WEBKIT + value + MS + "flex-item-" + replace(value, /flex-|-self/, "") + value;
    case 4675:
      return WEBKIT + value + MS + "flex-line-pack" + replace(value, /align-content|flex-|-self/, "") + value;
    case 5548:
      return WEBKIT + value + MS + replace(value, "shrink", "negative") + value;
    case 5292:
      return WEBKIT + value + MS + replace(value, "basis", "preferred-size") + value;
    case 6060:
      return WEBKIT + "box-" + replace(value, "-grow", "") + WEBKIT + value + MS + replace(value, "grow", "positive") + value;
    case 4554:
      return WEBKIT + replace(value, /([^-])(transform)/g, "$1" + WEBKIT + "$2") + value;
    case 6187:
      return replace(replace(replace(value, /(zoom-|grab)/, WEBKIT + "$1"), /(image-set)/, WEBKIT + "$1"), value, "") + value;
    case 5495:
    case 3959:
      return replace(value, /(image-set\([^]*)/, WEBKIT + "$1$`$1");
    case 4968:
      return replace(replace(value, /(.+:)(flex-)?(.*)/, WEBKIT + "box-pack:$3" + MS + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + WEBKIT + value + value;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return replace(value, /(.+)-inline(.+)/, WEBKIT + "$1$2") + value;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (strlen(value) - 1 - length2 > 6) switch (charat(value, length2 + 1)) {
        case 109:
          if (charat(value, length2 + 4) !== 45) break;
        case 102:
          return replace(value, /(.+:)(.+)-([^]+)/, "$1" + WEBKIT + "$2-$3$1" + MOZ + (charat(value, length2 + 3) == 108 ? "$3" : "$2-$3")) + value;
        case 115:
          return ~indexof(value, "stretch") ? prefix(replace(value, "stretch", "fill-available"), length2) + value : value;
      }
      break;
    case 4949:
      if (charat(value, length2 + 1) !== 115) break;
    case 6444:
      switch (charat(value, strlen(value) - 3 - (~indexof(value, "!important") && 10))) {
        case 107:
          return replace(value, ":", ":" + WEBKIT) + value;
        case 101:
          return replace(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + WEBKIT + (charat(value, 14) === 45 ? "inline-" : "") + "box$3$1" + WEBKIT + "$2$3$1" + MS + "$2box$3") + value;
      }
      break;
    case 5936:
      switch (charat(value, length2 + 11)) {
        case 114:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
        case 108:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
        case 45:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
      }
      return WEBKIT + value + MS + value + value;
  }
  return value;
}
function serialize(children, callback) {
  for (var output = "", length2 = sizeof(children), i = 0; i < length2; i++) output += callback(children[i], i, children, callback) || "";
  return output;
}
function stringify(element, index2, children, callback) {
  switch (element.type) {
    case IMPORT:
    case DECLARATION:
      return element.return = element.return || element.value;
    case COMMENT:
      return "";
    case KEYFRAMES:
      return element.return = element.value + "{" + serialize(element.children, callback) + "}";
    case RULESET:
      element.value = element.props.join(",");
  }
  return strlen(children = serialize(element.children, callback)) ? element.return = element.value + "{" + children + "}" : "";
}
function middleware(collection) {
  var length2 = sizeof(collection);
  return function (element, index2, children, callback) {
    for (var output = "", i = 0; i < length2; i++) output += collection[i](element, index2, children, callback) || "";
    return output;
  };
}
function rulesheet(callback) {
  return function (element) {
    element.root || (element = element.return) && callback(element);
  };
}
function prefixer(element, index2, children, callback) {
  if (element.length > -1 && !element.return) switch (element.type) {
    case DECLARATION:
      element.return = prefix(element.value, element.length);
      break;
    case KEYFRAMES:
      return serialize([copy(element, {
        value: replace(element.value, "@", "@" + WEBKIT)
      })], callback);
    case RULESET:
      if (element.length) return combine(element.props, function (value) {
        switch (match(value, /(::plac\w+|:read-\w+)/)) {
          case ":read-only":
          case ":read-write":
            return serialize([copy(element, {
              props: [replace(value, /:(read-\w+)/, ":" + MOZ + "$1")]
            })], callback);
          case "::placeholder":
            return serialize([copy(element, {
              props: [replace(value, /:(plac\w+)/, ":" + WEBKIT + "input-$1")]
            }), copy(element, {
              props: [replace(value, /:(plac\w+)/, ":" + MOZ + "$1")]
            }), copy(element, {
              props: [replace(value, /:(plac\w+)/, MS + "input-$1")]
            })], callback);
        }
        return "";
      });
  }
}
var weakMemoize = function (func) {
    var cache = new WeakMap();
    return function (arg) {
      if (cache.has(arg)) return cache.get(arg);
      var ret = func(arg);
      return cache.set(arg, ret), ret;
    };
  },
  weak_memoize_esm_default = weakMemoize;
var identifierWithPointTracking = function (begin, points, index2) {
    for (var previous = 0, character2 = 0; previous = character2, character2 = peek(), previous === 38 && character2 === 12 && (points[index2] = 1), !token(character2);) next();
    return slice(begin, position);
  },
  toRules = function (parsed, points) {
    var index2 = -1,
      character2 = 44;
    do switch (token(character2)) {
      case 0:
        character2 === 38 && peek() === 12 && (points[index2] = 1), parsed[index2] += identifierWithPointTracking(position - 1, points, index2);
        break;
      case 2:
        parsed[index2] += delimit(character2);
        break;
      case 4:
        if (character2 === 44) {
          parsed[++index2] = peek() === 58 ? "&\f" : "", points[index2] = parsed[index2].length;
          break;
        }
      default:
        parsed[index2] += from(character2);
    } while (character2 = next());
    return parsed;
  },
  getRules = function (value, points) {
    return dealloc(toRules(alloc(value), points));
  },
  fixedElements = new WeakMap(),
  compat = function (element) {
    if (!(element.type !== "rule" || !element.parent || element.length < 1)) {
      for (var value = element.value, parent = element.parent, isImplicitRule = element.column === parent.column && element.line === parent.line; parent.type !== "rule";) if (parent = parent.parent, !parent) return;
      if (!(element.props.length === 1 && value.charCodeAt(0) !== 58 && !fixedElements.get(parent)) && !isImplicitRule) {
        fixedElements.set(element, !0);
        for (var points = [], rules = getRules(value, points), parentRules = parent.props, i = 0, k = 0; i < rules.length; i++) for (var j = 0; j < parentRules.length; j++, k++) element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
      }
    }
  },
  removeLabel = function (element) {
    if (element.type === "decl") {
      var value = element.value;
      value.charCodeAt(0) === 108 && value.charCodeAt(2) === 98 && (element.return = "", element.value = "");
    }
  };
var isBrowser = typeof document < "u",
  getServerStylisCache = isBrowser ? void 0 : weak_memoize_esm_default(function () {
    return emotion_memoize_esm_default(function () {
      var cache = {};
      return function (name) {
        return cache[name];
      };
    });
  }),
  defaultStylisPlugins = [prefixer],
  createCache = function (options) {
    var key = options.key;
    if (isBrowser && key === "css") {
      var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])");
      Array.prototype.forEach.call(ssrStyles, function (node2) {
        var dataEmotionAttribute = node2.getAttribute("data-emotion");
        dataEmotionAttribute.indexOf(" ") !== -1 && (document.head.appendChild(node2), node2.setAttribute("data-s", ""));
      });
    }
    var stylisPlugins = options.stylisPlugins || defaultStylisPlugins,
      inserted = {},
      container,
      nodesToHydrate = [];
    isBrowser && (container = options.container || document.head, Array.prototype.forEach.call(document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function (node2) {
      for (var attrib = node2.getAttribute("data-emotion").split(" "), i = 1; i < attrib.length; i++) inserted[attrib[i]] = !0;
      nodesToHydrate.push(node2);
    }));
    var _insert,
      omnipresentPlugins = [compat, removeLabel];
    if (isBrowser) {
      var currentSheet,
        finalizingPlugins = [stringify, rulesheet(function (rule) {
          currentSheet.insert(rule);
        })],
        serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins)),
        stylis = function (styles) {
          return serialize(compile(styles), serializer);
        };
      _insert = function (selector, serialized, sheet, shouldCache) {
        currentSheet = sheet, stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles), shouldCache && (cache.inserted[serialized.name] = !0);
      };
    } else {
      var _finalizingPlugins = [stringify],
        _serializer = middleware(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins)),
        _stylis = function (styles) {
          return serialize(compile(styles), _serializer);
        },
        serverStylisCache = getServerStylisCache(stylisPlugins)(key),
        getRules3 = function (selector, serialized) {
          var name = serialized.name;
          return serverStylisCache[name] === void 0 && (serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles)), serverStylisCache[name];
        };
      _insert = function (selector, serialized, sheet, shouldCache) {
        var name = serialized.name,
          rules = getRules3(selector, serialized);
        if (cache.compat === void 0) return shouldCache && (cache.inserted[name] = !0), rules;
        if (shouldCache) cache.inserted[name] = rules;else return rules;
      };
    }
    var cache = {
      key,
      sheet: new StyleSheet({
        key,
        container,
        nonce: options.nonce,
        speedy: options.speedy,
        prepend: options.prepend,
        insertionPoint: options.insertionPoint
      }),
      nonce: options.nonce,
      inserted,
      registered: {},
      insert: _insert
    };
    return cache.sheet.hydrate(nodesToHydrate), cache;
  },
  emotion_cache_esm_default = createCache;
import { createContext, useContext, forwardRef, createElement, Fragment } from "react";
var import_hoist_non_react_statics = __toESM(require_hoist_non_react_statics_cjs()),
  hoistNonReactStatics = function (targetComponent, sourceComponent) {
    return (0, import_hoist_non_react_statics.default)(targetComponent, sourceComponent);
  },
  emotion_react_isolated_hnrs_esm_default = hoistNonReactStatics;
var isBrowser2 = typeof document < "u";
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = "";
  return classNames.split(" ").forEach(function (className) {
    registered[className] !== void 0 ? registeredStyles.push(registered[className] + ";") : rawClassName += className + " ";
  }), rawClassName;
}
var registerStyles = function (cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    (isStringTag === !1 || isBrowser2 === !1 && cache.compat !== void 0) && cache.registered[className] === void 0 && (cache.registered[className] = serialized.styles);
  },
  insertStyles = function (cache, serialized, isStringTag) {
    registerStyles(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === void 0) {
      var stylesForSSR = "",
        current = serialized;
      do {
        var maybeStyles = cache.insert(serialized === current ? "." + className : "", current, cache.sheet, !0);
        !isBrowser2 && maybeStyles !== void 0 && (stylesForSSR += maybeStyles), current = current.next;
      } while (current !== void 0);
      if (!isBrowser2 && stylesForSSR.length !== 0) return stylesForSSR;
    }
  };
function murmur2(str) {
  for (var h = 0, k, i = 0, len = str.length; len >= 4; ++i, len -= 4) k = str.charCodeAt(i) & 255 | (str.charCodeAt(++i) & 255) << 8 | (str.charCodeAt(++i) & 255) << 16 | (str.charCodeAt(++i) & 255) << 24, k = (k & 65535) * 1540483477 + ((k >>> 16) * 59797 << 16), k ^= k >>> 24, h = (k & 65535) * 1540483477 + ((k >>> 16) * 59797 << 16) ^ (h & 65535) * 1540483477 + ((h >>> 16) * 59797 << 16);
  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 255) << 16;
    case 2:
      h ^= (str.charCodeAt(i + 1) & 255) << 8;
    case 1:
      h ^= str.charCodeAt(i) & 255, h = (h & 65535) * 1540483477 + ((h >>> 16) * 59797 << 16);
  }
  return h ^= h >>> 13, h = (h & 65535) * 1540483477 + ((h >>> 16) * 59797 << 16), ((h ^ h >>> 15) >>> 0).toString(36);
}
var hash_esm_default = murmur2;
var unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
  },
  unitless_esm_default = unitlessKeys;
var hyphenateRegex = /[A-Z]|^ms/g,
  animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g,
  isCustomProperty = function (property) {
    return property.charCodeAt(1) === 45;
  },
  isProcessableValue = function (value) {
    return value != null && typeof value != "boolean";
  },
  processStyleName = emotion_memoize_esm_default(function (styleName) {
    return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, "-$&").toLowerCase();
  }),
  processStyleValue = function (key, value) {
    switch (key) {
      case "animation":
      case "animationName":
        if (typeof value == "string") return value.replace(animationRegex, function (match2, p1, p2) {
          return cursor = {
            name: p1,
            styles: p2,
            next: cursor
          }, p1;
        });
    }
    return unitless_esm_default[key] !== 1 && !isCustomProperty(key) && typeof value == "number" && value !== 0 ? value + "px" : value;
  };
function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) return "";
  if (interpolation.__emotion_styles !== void 0) return interpolation;
  switch (typeof interpolation) {
    case "boolean":
      return "";
    case "object":
      {
        if (interpolation.anim === 1) return cursor = {
          name: interpolation.name,
          styles: interpolation.styles,
          next: cursor
        }, interpolation.name;
        if (interpolation.styles !== void 0) {
          var next2 = interpolation.next;
          if (next2 !== void 0) for (; next2 !== void 0;) cursor = {
            name: next2.name,
            styles: next2.styles,
            next: cursor
          }, next2 = next2.next;
          var styles = interpolation.styles + ";";
          return styles;
        }
        return createStringFromObject(mergedProps, registered, interpolation);
      }
    case "function":
      {
        if (mergedProps !== void 0) {
          var previousCursor = cursor,
            result = interpolation(mergedProps);
          return cursor = previousCursor, handleInterpolation(mergedProps, registered, result);
        }
        break;
      }
    case "string":
      if (!1) var matched, replaced;
      break;
  }
  if (registered == null) return interpolation;
  var cached = registered[interpolation];
  return cached !== void 0 ? cached : interpolation;
}
function createStringFromObject(mergedProps, registered, obj) {
  var string = "";
  if (Array.isArray(obj)) for (var i = 0; i < obj.length; i++) string += handleInterpolation(mergedProps, registered, obj[i]) + ";";else for (var _key in obj) {
    var value = obj[_key];
    if (typeof value != "object") registered != null && registered[value] !== void 0 ? string += _key + "{" + registered[value] + "}" : isProcessableValue(value) && (string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";");else if (Array.isArray(value) && typeof value[0] == "string" && (registered == null || registered[value[0]] === void 0)) for (var _i = 0; _i < value.length; _i++) isProcessableValue(value[_i]) && (string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";");else {
      var interpolated = handleInterpolation(mergedProps, registered, value);
      switch (_key) {
        case "animation":
        case "animationName":
          {
            string += processStyleName(_key) + ":" + interpolated + ";";
            break;
          }
        default:
          string += _key + "{" + interpolated + "}";
      }
    }
  }
  return string;
}
var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var cursor,
  serializeStyles = function (args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] == "object" && args[0] !== null && args[0].styles !== void 0) return args[0];
    var stringMode = !0,
      styles = "";
    cursor = void 0;
    var strings = args[0];
    strings == null || strings.raw === void 0 ? (stringMode = !1, styles += handleInterpolation(mergedProps, registered, strings)) : styles += strings[0];
    for (var i = 1; i < args.length; i++) styles += handleInterpolation(mergedProps, registered, args[i]), stringMode && (styles += strings[i]);
    var sourceMap;
    labelPattern.lastIndex = 0;
    for (var identifierName = "", match2; (match2 = labelPattern.exec(styles)) !== null;) identifierName += "-" + match2[1];
    var name = hash_esm_default(styles) + identifierName;
    return {
      name,
      styles,
      next: cursor
    };
  };
var isBrowser3 = typeof document < "u",
  hasOwnProperty = {}.hasOwnProperty,
  EmotionCacheContext = createContext(typeof HTMLElement < "u" ? emotion_cache_esm_default({
    key: "css"
  }) : null),
  CacheProvider = EmotionCacheContext.Provider;
var withEmotionCache = function (func) {
  return forwardRef(function (props2, ref) {
    var cache = useContext(EmotionCacheContext);
    return func(props2, cache, ref);
  });
};
isBrowser3 || (withEmotionCache = function (func) {
  return function (props2) {
    var cache = useContext(EmotionCacheContext);
    return cache === null ? (cache = emotion_cache_esm_default({
      key: "css"
    }), createElement(EmotionCacheContext.Provider, {
      value: cache
    }, func(props2, cache))) : func(props2, cache);
  };
});
var ThemeContext = createContext({});
var getTheme = function (outerTheme, theme) {
    if (typeof theme == "function") {
      var mergedTheme = theme(outerTheme);
      return mergedTheme;
    }
    return _extends({}, outerTheme, theme);
  },
  createCacheWithTheme = weak_memoize_esm_default(function (outerTheme) {
    return weak_memoize_esm_default(function (theme) {
      return getTheme(outerTheme, theme);
    });
  }),
  ThemeProvider = function (props2) {
    var theme = useContext(ThemeContext);
    return props2.theme !== theme && (theme = createCacheWithTheme(theme)(props2.theme)), createElement(ThemeContext.Provider, {
      value: theme
    }, props2.children);
  };
function withTheme(Component) {
  var componentName = Component.displayName || Component.name || "Component",
    render = function (props2, ref) {
      var theme = useContext(ThemeContext);
      return createElement(Component, _extends({
        theme,
        ref
      }, props2));
    },
    WithTheme = forwardRef(render);
  return WithTheme.displayName = "WithTheme(" + componentName + ")", emotion_react_isolated_hnrs_esm_default(WithTheme, Component);
}
var import_extends2 = __toESM(require_extends());
var import_hoist_non_react_statics2 = __toESM(require_hoist_non_react_statics_cjs());
var Global = withEmotionCache(function (props2, cache) {
  var styles = props2.styles,
    serialized = serializeStyles([styles], void 0, useContext2(ThemeContext));
  if (!isBrowser3) {
    for (var _ref, serializedNames = serialized.name, serializedStyles = serialized.styles, next2 = serialized.next; next2 !== void 0;) serializedNames += " " + next2.name, serializedStyles += next2.styles, next2 = next2.next;
    var shouldCache = cache.compat === !0,
      rules = cache.insert("", {
        name: serializedNames,
        styles: serializedStyles
      }, cache.sheet, shouldCache);
    return shouldCache ? null : createElement2("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
      __html: rules
    }, _ref.nonce = cache.sheet.nonce, _ref));
  }
  var sheetRef = useRef();
  return useLayoutEffect(function () {
    var key = cache.key + "-global",
      sheet = new StyleSheet({
        key,
        nonce: cache.sheet.nonce,
        container: cache.sheet.container,
        speedy: cache.sheet.isSpeedy
      }),
      rehydrating = !1,
      node2 = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
    return cache.sheet.tags.length && (sheet.before = cache.sheet.tags[0]), node2 !== null && (rehydrating = !0, node2.setAttribute("data-emotion", key), sheet.hydrate([node2])), sheetRef.current = [sheet, rehydrating], function () {
      sheet.flush();
    };
  }, [cache]), useLayoutEffect(function () {
    var sheetRefCurrent = sheetRef.current,
      sheet = sheetRefCurrent[0],
      rehydrating = sheetRefCurrent[1];
    if (rehydrating) {
      sheetRefCurrent[1] = !1;
      return;
    }
    if (serialized.next !== void 0 && insertStyles(cache, serialized.next, !0), sheet.tags.length) {
      var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
      sheet.before = element, sheet.flush();
    }
    cache.insert("", serialized, sheet, !1);
  }, [cache, serialized.name]), null;
});
function css() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
  return serializeStyles(args);
}
var keyframes = function () {
  var insertable = css.apply(void 0, arguments),
    name = "animation-" + insertable.name;
  return {
    name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function () {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};
var testOmitPropsOnStringTag = emotion_is_prop_valid_esm_default,
  testOmitPropsOnComponent = function (key) {
    return key !== "theme";
  },
  getDefaultShouldForwardProp = function (tag) {
    return typeof tag == "string" && tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
  },
  composeShouldForwardProps = function (tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
      var optionsShouldForwardProp = options.shouldForwardProp;
      shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function (propName) {
        return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
      } : optionsShouldForwardProp;
    }
    return typeof shouldForwardProp != "function" && isReal && (shouldForwardProp = tag.__emotion_forwardProp), shouldForwardProp;
  };
var isBrowser4 = typeof document < "u",
  Noop = function () {
    return null;
  },
  createStyled = function createStyled2(tag, options) {
    var isReal = tag.__emotion_real === tag,
      baseTag = isReal && tag.__emotion_base || tag,
      identifierName,
      targetClassName;
    options !== void 0 && (identifierName = options.label, targetClassName = options.target);
    var shouldForwardProp = composeShouldForwardProps(tag, options, isReal),
      defaultShouldForwardProp = shouldForwardProp || getDefaultShouldForwardProp(baseTag),
      shouldUseAs = !defaultShouldForwardProp("as");
    return function () {
      var args = arguments,
        styles = isReal && tag.__emotion_styles !== void 0 ? tag.__emotion_styles.slice(0) : [];
      if (identifierName !== void 0 && styles.push("label:" + identifierName + ";"), args[0] == null || args[0].raw === void 0) styles.push.apply(styles, args);else {
        styles.push(args[0][0]);
        for (var len = args.length, i = 1; i < len; i++) styles.push(args[i], args[0][i]);
      }
      var Styled = withEmotionCache(function (props2, cache, ref) {
        var finalTag = shouldUseAs && props2.as || baseTag,
          className = "",
          classInterpolations = [],
          mergedProps = props2;
        if (props2.theme == null) {
          mergedProps = {};
          for (var key in props2) mergedProps[key] = props2[key];
          mergedProps.theme = useContext3(ThemeContext);
        }
        typeof props2.className == "string" ? className = getRegisteredStyles(cache.registered, classInterpolations, props2.className) : props2.className != null && (className = props2.className + " ");
        var serialized = serializeStyles(styles.concat(classInterpolations), cache.registered, mergedProps),
          rules = insertStyles(cache, serialized, typeof finalTag == "string");
        className += cache.key + "-" + serialized.name, targetClassName !== void 0 && (className += " " + targetClassName);
        var finalShouldForwardProp = shouldUseAs && shouldForwardProp === void 0 ? getDefaultShouldForwardProp(finalTag) : defaultShouldForwardProp,
          newProps = {};
        for (var _key in props2) shouldUseAs && _key === "as" || finalShouldForwardProp(_key) && (newProps[_key] = props2[_key]);
        newProps.className = className, newProps.ref = ref;
        var ele = createElement3(finalTag, newProps),
          possiblyStyleElement = createElement3(Noop, null);
        if (!isBrowser4 && rules !== void 0) {
          for (var _ref, serializedNames = serialized.name, next2 = serialized.next; next2 !== void 0;) serializedNames += " " + next2.name, next2 = next2.next;
          possiblyStyleElement = createElement3("style", (_ref = {}, _ref["data-emotion"] = cache.key + " " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
          }, _ref.nonce = cache.sheet.nonce, _ref));
        }
        return createElement3(Fragment3, null, possiblyStyleElement, ele);
      });
      return Styled.displayName = identifierName !== void 0 ? identifierName : "Styled(" + (typeof baseTag == "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")", Styled.defaultProps = tag.defaultProps, Styled.__emotion_real = Styled, Styled.__emotion_base = baseTag, Styled.__emotion_styles = styles, Styled.__emotion_forwardProp = shouldForwardProp, Object.defineProperty(Styled, "toString", {
        value: function () {
          return "." + targetClassName;
        }
      }), Styled.withComponent = function (nextTag, nextOptions) {
        return createStyled2(nextTag, _extends({}, options, nextOptions, {
          shouldForwardProp: composeShouldForwardProps(Styled, nextOptions, !0)
        })).apply(void 0, styles);
      }, Styled;
    };
  },
  emotion_styled_base_esm_default = createStyled;
var tags = ["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "marquee", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "tspan"],
  newStyled = emotion_styled_base_esm_default.bind();
tags.forEach(function (tagName) {
  newStyled[tagName] = newStyled(tagName);
});
var emotion_styled_esm_default = newStyled;
var get = (object, key, fallback) => {
    let keyAsArray = key && typeof key == "string" ? key.split(".") : [key],
      values = object;
    return keyAsArray.forEach(k => {
      values = values ? values[k] : void 0;
    }), values === void 0 ? fallback : values;
  },
  defaultBreakpoints = [40, 52, 64].map(n => "".concat(n, "em")),
  defaultTheme = {
    space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
    fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72]
  },
  aliases = {
    bg: "backgroundColor",
    m: "margin",
    mt: "marginTop",
    mr: "marginRight",
    mb: "marginBottom",
    ml: "marginLeft",
    mx: "marginX",
    my: "marginY",
    p: "padding",
    pt: "paddingTop",
    pr: "paddingRight",
    pb: "paddingBottom",
    pl: "paddingLeft",
    px: "paddingX",
    py: "paddingY"
  },
  multiples = {
    marginX: ["marginLeft", "marginRight"],
    marginY: ["marginTop", "marginBottom"],
    paddingX: ["paddingLeft", "paddingRight"],
    paddingY: ["paddingTop", "paddingBottom"],
    size: ["width", "height"]
  },
  scales = {
    color: "textColors",
    backgroundColor: "backgroundColors",
    borderColor: "borderColors",
    margin: "space",
    marginTop: "space",
    marginRight: "space",
    marginBottom: "space",
    marginLeft: "space",
    marginX: "space",
    marginY: "space",
    padding: "space",
    paddingTop: "space",
    paddingRight: "space",
    paddingBottom: "space",
    paddingLeft: "space",
    paddingX: "space",
    paddingY: "space",
    top: "space",
    right: "space",
    bottom: "space",
    left: "space",
    gridGap: "space",
    gridColumnGap: "space",
    gridRowGap: "space",
    gap: "space",
    columnGap: "space",
    rowGap: "space",
    fontFamily: "fonts",
    fontSize: "fontSizes",
    fontWeight: "fontWeights",
    lineHeight: "lineHeights",
    letterSpacing: "letterSpacings",
    border: "borders",
    borderTop: "borders",
    borderRight: "borders",
    borderBottom: "borders",
    borderLeft: "borders",
    borderWidth: "borderWidths",
    borderStyle: "borderStyles",
    borderRadius: "radii",
    borderTopRightRadius: "radii",
    borderTopLeftRadius: "radii",
    borderBottomRightRadius: "radii",
    borderBottomLeftRadius: "radii",
    borderTopWidth: "borderWidths",
    borderTopColor: "borderColors",
    borderTopStyle: "borderStyles",
    borderBottomWidth: "borderWidths",
    borderBottomColor: "borderColors",
    borderBottomStyle: "borderStyles",
    borderLeftWidth: "borderWidths",
    borderLeftColor: "borderColors",
    borderLeftStyle: "borderStyles",
    borderRightWidth: "borderWidths",
    borderRightColor: "borderColors",
    borderRightStyle: "borderStyles",
    outlineColor: "outlineColors",
    boxShadow: "shadows",
    textShadow: "shadows",
    zIndex: "zIndices",
    width: "sizes",
    minWidth: "sizes",
    maxWidth: "sizes",
    height: "sizes",
    minHeight: "sizes",
    maxHeight: "sizes",
    flexBasis: "sizes",
    size: "sizes",
    "-webkit-text-fill-color": "textColors",
    fill: "fillColors",
    stroke: "strokeColors"
  },
  positiveOrNegative = (scale, value) => {
    if (typeof value != "number" || value >= 0) return get(scale, value, value);
    let absolute = Math.abs(value),
      n = get(scale, absolute, absolute);
    return typeof n == "string" ? "-".concat(n) : n * -1;
  },
  transforms = ["margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "top", "bottom", "left", "right"].reduce((acc, curr) => __spreadProps(__spreadValues({}, acc), {
    [curr]: positiveOrNegative
  }), {}),
  responsive = styles => theme => {
    let next2 = {},
      mediaQueries = [null, ...get(theme, "breakpoints", defaultBreakpoints).map(n => "@media screen and (min-width: ".concat(n, ")"))];
    for (let key in styles) {
      let value = typeof styles[key] == "function" ? styles[key](theme) : styles[key];
      if (value != null) {
        if (!Array.isArray(value)) {
          next2[key] = value;
          continue;
        }
        for (let i = 0; i < value.slice(0, mediaQueries.length).length; i++) {
          let media = mediaQueries[i];
          if (!media) {
            next2[key] = value[i];
            continue;
          }
          next2[media] = next2[media] || {}, value[i] != null && (next2[media][key] = value[i]);
        }
      }
    }
    return next2;
  },
  css2 = args => function () {
    let props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let theme = __spreadValues(__spreadValues({}, defaultTheme), props2.theme || props2),
      result = {},
      obj = typeof args == "function" ? args(theme) : args,
      styles = responsive(obj)(theme);
    for (let key in styles) {
      let x = styles[key],
        val = typeof x == "function" ? x(theme) : x;
      if (key === "variant") {
        let variant3 = css2(get(theme, val))(theme);
        result = __spreadValues(__spreadValues({}, result), variant3);
        continue;
      }
      if (val && typeof val == "object") {
        result[key] = css2(val)(theme);
        continue;
      }
      let prop = get(aliases, key, key),
        scaleName = get(scales, prop),
        scale = get(theme, scaleName, get(theme, prop, {})),
        value = get(transforms, prop, get)(scale, val, val);
      if (multiples[prop]) {
        let dirs = multiples[prop];
        for (let dir of dirs) result[dir] = value;
      } else result[prop] = value;
    }
    return result;
  };
var import_object_assign = __toESM(require_object_assign()),
  merge = function (a, b) {
    var result = (0, import_object_assign.default)({}, a, b);
    for (var key in a) {
      var _assign;
      !a[key] || typeof b[key] != "object" || (0, import_object_assign.default)(result, (_assign = {}, _assign[key] = (0, import_object_assign.default)(a[key], b[key]), _assign));
    }
    return result;
  },
  sort = function (obj) {
    var next2 = {};
    return Object.keys(obj).sort(function (a, b) {
      return a.localeCompare(b, void 0, {
        numeric: !0,
        sensitivity: "base"
      });
    }).forEach(function (key) {
      next2[key] = obj[key];
    }), next2;
  },
  defaults = {
    breakpoints: [40, 52, 64].map(function (n) {
      return n + "em";
    })
  },
  createMediaQuery = function (n) {
    return "@media screen and (min-width: " + n + ")";
  },
  getValue = function (n, scale) {
    return get2(scale, n, n);
  },
  get2 = function (obj, key, def, p, undef) {
    for (key = key && key.split ? key.split(".") : [key], p = 0; p < key.length; p++) obj = obj ? obj[key[p]] : undef;
    return obj === undef ? def : obj;
  },
  createParser = function createParser2(config9) {
    var cache = {},
      parse2 = function (props2) {
        var styles = {},
          shouldSort = !1,
          isCacheDisabled = props2.theme && props2.theme.disableStyledSystemCache;
        for (var key in props2) if (!!config9[key]) {
          var sx = config9[key],
            raw = props2[key],
            scale = get2(props2.theme, sx.scale, sx.defaults);
          if (typeof raw == "object") {
            if (cache.breakpoints = !isCacheDisabled && cache.breakpoints || get2(props2.theme, "breakpoints", defaults.breakpoints), Array.isArray(raw)) {
              cache.media = !isCacheDisabled && cache.media || [null].concat(cache.breakpoints.map(createMediaQuery)), styles = merge(styles, parseResponsiveStyle(cache.media, sx, scale, raw, props2));
              continue;
            }
            raw !== null && (styles = merge(styles, parseResponsiveObject(cache.breakpoints, sx, scale, raw, props2)), shouldSort = !0);
            continue;
          }
          (0, import_object_assign.default)(styles, sx(raw, scale, props2));
        }
        return shouldSort && (styles = sort(styles)), styles;
      };
    parse2.config = config9, parse2.propNames = Object.keys(config9), parse2.cache = cache;
    var keys = Object.keys(config9).filter(function (k) {
      return k !== "config";
    });
    return keys.length > 1 && keys.forEach(function (key) {
      var _createParser;
      parse2[key] = createParser2((_createParser = {}, _createParser[key] = config9[key], _createParser));
    }), parse2;
  },
  parseResponsiveStyle = function (mediaQueries, sx, scale, raw, _props) {
    var styles = {};
    return raw.slice(0, mediaQueries.length).forEach(function (value, i) {
      var media = mediaQueries[i],
        style3 = sx(value, scale, _props);
      if (!media) (0, import_object_assign.default)(styles, style3);else {
        var _assign2;
        (0, import_object_assign.default)(styles, (_assign2 = {}, _assign2[media] = (0, import_object_assign.default)({}, styles[media], style3), _assign2));
      }
    }), styles;
  },
  parseResponsiveObject = function (breakpoints, sx, scale, raw, _props) {
    var styles = {};
    for (var key in raw) {
      var breakpoint = breakpoints[key],
        value = raw[key],
        style3 = sx(value, scale, _props);
      if (!breakpoint) (0, import_object_assign.default)(styles, style3);else {
        var _assign3,
          media = createMediaQuery(breakpoint);
        (0, import_object_assign.default)(styles, (_assign3 = {}, _assign3[media] = (0, import_object_assign.default)({}, styles[media], style3), _assign3));
      }
    }
    return styles;
  },
  createStyleFunction = function (_ref) {
    var properties = _ref.properties,
      property = _ref.property,
      scale = _ref.scale,
      _ref$transform = _ref.transform,
      transform = _ref$transform === void 0 ? getValue : _ref$transform,
      defaultScale = _ref.defaultScale;
    properties = properties || [property];
    var sx = function (value, scale2, _props) {
      var result = {},
        n = transform(value, scale2, _props);
      if (n !== null) return properties.forEach(function (prop) {
        result[prop] = n;
      }), result;
    };
    return sx.scale = scale, sx.defaults = defaultScale, sx;
  },
  system = function (args) {
    args === void 0 && (args = {});
    var config9 = {};
    Object.keys(args).forEach(function (key) {
      var conf = args[key];
      if (conf === !0) {
        config9[key] = createStyleFunction({
          property: key,
          scale: key
        });
        return;
      }
      if (typeof conf == "function") {
        config9[key] = conf;
        return;
      }
      config9[key] = createStyleFunction(conf);
    });
    var parser = createParser(config9);
    return parser;
  },
  compose = function () {
    for (var config9 = {}, _len = arguments.length, parsers = new Array(_len), _key = 0; _key < _len; _key++) parsers[_key] = arguments[_key];
    parsers.forEach(function (parser2) {
      !parser2 || !parser2.config || (0, import_object_assign.default)(config9, parser2.config);
    });
    var parser = createParser(config9);
    return parser;
  };
var themeGet = function (path, fallback) {
  return fallback === void 0 && (fallback = null), function (props2) {
    return get2(props2.theme, path, fallback);
  };
};
function memoize2(fn) {
  var cache = {};
  return function (arg) {
    return cache[arg] === void 0 && (cache[arg] = fn(arg)), cache[arg];
  };
}
var memoize_esm_default = memoize2;
var reactPropsRegex2 = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/,
  index = memoize_esm_default(function (prop) {
    return reactPropsRegex2.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
  }),
  is_prop_valid_esm_default = index;
var isNumber = function (n) {
    return typeof n == "number" && !isNaN(n);
  },
  getWidth = function (n, scale) {
    return get2(scale, n, !isNumber(n) || n > 1 ? n : n * 100 + "%");
  },
  config = {
    width: {
      property: "width",
      scale: "sizes",
      transform: getWidth
    },
    height: {
      property: "height",
      scale: "sizes"
    },
    minWidth: {
      property: "minWidth",
      scale: "sizes"
    },
    minHeight: {
      property: "minHeight",
      scale: "sizes"
    },
    maxWidth: {
      property: "maxWidth",
      scale: "sizes"
    },
    maxHeight: {
      property: "maxHeight",
      scale: "sizes"
    },
    size: {
      properties: ["width", "height"],
      scale: "sizes"
    },
    overflow: !0,
    overflowX: !0,
    overflowY: !0,
    display: !0,
    verticalAlign: !0
  },
  layout = system(config),
  index_esm_default = layout;
var config2 = {
  color: {
    property: "color",
    scale: "colors"
  },
  backgroundColor: {
    property: "backgroundColor",
    scale: "colors"
  },
  opacity: !0
};
config2.bg = config2.backgroundColor;
var color = system(config2),
  index_esm_default2 = color;
var defaults2 = {
    fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72]
  },
  config3 = {
    fontFamily: {
      property: "fontFamily",
      scale: "fonts"
    },
    fontSize: {
      property: "fontSize",
      scale: "fontSizes",
      defaultScale: defaults2.fontSizes
    },
    fontWeight: {
      property: "fontWeight",
      scale: "fontWeights"
    },
    lineHeight: {
      property: "lineHeight",
      scale: "lineHeights"
    },
    letterSpacing: {
      property: "letterSpacing",
      scale: "letterSpacings"
    },
    textAlign: !0,
    fontStyle: !0
  },
  typography = system(config3),
  index_esm_default3 = typography;
var config4 = {
    alignItems: !0,
    alignContent: !0,
    justifyItems: !0,
    justifyContent: !0,
    flexWrap: !0,
    flexDirection: !0,
    flex: !0,
    flexGrow: !0,
    flexShrink: !0,
    flexBasis: !0,
    justifySelf: !0,
    alignSelf: !0,
    order: !0
  },
  flexbox = system(config4),
  index_esm_default4 = flexbox;
var defaults3 = {
    space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
  },
  config5 = {
    gridGap: {
      property: "gridGap",
      scale: "space",
      defaultScale: defaults3.space
    },
    gridColumnGap: {
      property: "gridColumnGap",
      scale: "space",
      defaultScale: defaults3.space
    },
    gridRowGap: {
      property: "gridRowGap",
      scale: "space",
      defaultScale: defaults3.space
    },
    gridColumn: !0,
    gridRow: !0,
    gridAutoFlow: !0,
    gridAutoColumns: !0,
    gridAutoRows: !0,
    gridTemplateColumns: !0,
    gridTemplateRows: !0,
    gridTemplateAreas: !0,
    gridArea: !0
  },
  grid = system(config5),
  index_esm_default5 = grid;
var config6 = {
  border: {
    property: "border",
    scale: "borders"
  },
  borderWidth: {
    property: "borderWidth",
    scale: "borderWidths"
  },
  borderStyle: {
    property: "borderStyle",
    scale: "borderStyles"
  },
  borderColor: {
    property: "borderColor",
    scale: "colors"
  },
  borderRadius: {
    property: "borderRadius",
    scale: "radii"
  },
  borderTop: {
    property: "borderTop",
    scale: "borders"
  },
  borderTopLeftRadius: {
    property: "borderTopLeftRadius",
    scale: "radii"
  },
  borderTopRightRadius: {
    property: "borderTopRightRadius",
    scale: "radii"
  },
  borderRight: {
    property: "borderRight",
    scale: "borders"
  },
  borderBottom: {
    property: "borderBottom",
    scale: "borders"
  },
  borderBottomLeftRadius: {
    property: "borderBottomLeftRadius",
    scale: "radii"
  },
  borderBottomRightRadius: {
    property: "borderBottomRightRadius",
    scale: "radii"
  },
  borderLeft: {
    property: "borderLeft",
    scale: "borders"
  },
  borderX: {
    properties: ["borderLeft", "borderRight"],
    scale: "borders"
  },
  borderY: {
    properties: ["borderTop", "borderBottom"],
    scale: "borders"
  }
};
config6.borderTopWidth = {
  property: "borderTopWidth",
  scale: "borderWidths"
};
config6.borderTopColor = {
  property: "borderTopColor",
  scale: "colors"
};
config6.borderTopStyle = {
  property: "borderTopStyle",
  scale: "borderStyles"
};
config6.borderTopLeftRadius = {
  property: "borderTopLeftRadius",
  scale: "radii"
};
config6.borderTopRightRadius = {
  property: "borderTopRightRadius",
  scale: "radii"
};
config6.borderBottomWidth = {
  property: "borderBottomWidth",
  scale: "borderWidths"
};
config6.borderBottomColor = {
  property: "borderBottomColor",
  scale: "colors"
};
config6.borderBottomStyle = {
  property: "borderBottomStyle",
  scale: "borderStyles"
};
config6.borderBottomLeftRadius = {
  property: "borderBottomLeftRadius",
  scale: "radii"
};
config6.borderBottomRightRadius = {
  property: "borderBottomRightRadius",
  scale: "radii"
};
config6.borderLeftWidth = {
  property: "borderLeftWidth",
  scale: "borderWidths"
};
config6.borderLeftColor = {
  property: "borderLeftColor",
  scale: "colors"
};
config6.borderLeftStyle = {
  property: "borderLeftStyle",
  scale: "borderStyles"
};
config6.borderRightWidth = {
  property: "borderRightWidth",
  scale: "borderWidths"
};
config6.borderRightColor = {
  property: "borderRightColor",
  scale: "colors"
};
config6.borderRightStyle = {
  property: "borderRightStyle",
  scale: "borderStyles"
};
var border = system(config6),
  index_esm_default6 = border;
var config7 = {
  background: !0,
  backgroundImage: !0,
  backgroundSize: !0,
  backgroundPosition: !0,
  backgroundRepeat: !0
};
config7.bgImage = config7.backgroundImage;
config7.bgSize = config7.backgroundSize;
config7.bgPosition = config7.backgroundPosition;
config7.bgRepeat = config7.backgroundRepeat;
var background = system(config7),
  index_esm_default7 = background;
var defaults4 = {
    space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
  },
  config8 = {
    position: !0,
    zIndex: {
      property: "zIndex",
      scale: "zIndices"
    },
    top: {
      property: "top",
      scale: "space",
      defaultScale: defaults4.space
    },
    right: {
      property: "right",
      scale: "space",
      defaultScale: defaults4.space
    },
    bottom: {
      property: "bottom",
      scale: "space",
      defaultScale: defaults4.space
    },
    left: {
      property: "left",
      scale: "space",
      defaultScale: defaults4.space
    }
  },
  position2 = system(config8),
  index_esm_default8 = position2;
var defaults5 = {
    space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
  },
  isNumber3 = function (n) {
    return typeof n == "number" && !isNaN(n);
  },
  getMargin = function (n, scale) {
    if (!isNumber3(n)) return get2(scale, n, n);
    var isNegative = n < 0,
      absolute = Math.abs(n),
      value = get2(scale, absolute, absolute);
    return isNumber3(value) ? value * (isNegative ? -1 : 1) : isNegative ? "-" + value : value;
  },
  configs = {};
configs.margin = {
  margin: {
    property: "margin",
    scale: "space",
    transform: getMargin,
    defaultScale: defaults5.space
  },
  marginTop: {
    property: "marginTop",
    scale: "space",
    transform: getMargin,
    defaultScale: defaults5.space
  },
  marginRight: {
    property: "marginRight",
    scale: "space",
    transform: getMargin,
    defaultScale: defaults5.space
  },
  marginBottom: {
    property: "marginBottom",
    scale: "space",
    transform: getMargin,
    defaultScale: defaults5.space
  },
  marginLeft: {
    property: "marginLeft",
    scale: "space",
    transform: getMargin,
    defaultScale: defaults5.space
  },
  marginX: {
    properties: ["marginLeft", "marginRight"],
    scale: "space",
    transform: getMargin,
    defaultScale: defaults5.space
  },
  marginY: {
    properties: ["marginTop", "marginBottom"],
    scale: "space",
    transform: getMargin,
    defaultScale: defaults5.space
  }
};
configs.margin.m = configs.margin.margin;
configs.margin.mt = configs.margin.marginTop;
configs.margin.mr = configs.margin.marginRight;
configs.margin.mb = configs.margin.marginBottom;
configs.margin.ml = configs.margin.marginLeft;
configs.margin.mx = configs.margin.marginX;
configs.margin.my = configs.margin.marginY;
configs.padding = {
  padding: {
    property: "padding",
    scale: "space",
    defaultScale: defaults5.space
  },
  paddingTop: {
    property: "paddingTop",
    scale: "space",
    defaultScale: defaults5.space
  },
  paddingRight: {
    property: "paddingRight",
    scale: "space",
    defaultScale: defaults5.space
  },
  paddingBottom: {
    property: "paddingBottom",
    scale: "space",
    defaultScale: defaults5.space
  },
  paddingLeft: {
    property: "paddingLeft",
    scale: "space",
    defaultScale: defaults5.space
  },
  paddingX: {
    properties: ["paddingLeft", "paddingRight"],
    scale: "space",
    defaultScale: defaults5.space
  },
  paddingY: {
    properties: ["paddingTop", "paddingBottom"],
    scale: "space",
    defaultScale: defaults5.space
  }
};
configs.padding.p = configs.padding.padding;
configs.padding.pt = configs.padding.paddingTop;
configs.padding.pr = configs.padding.paddingRight;
configs.padding.pb = configs.padding.paddingBottom;
configs.padding.pl = configs.padding.paddingLeft;
configs.padding.px = configs.padding.paddingX;
configs.padding.py = configs.padding.paddingY;
var margin = system(configs.margin),
  padding = system(configs.padding),
  space = compose(margin, padding);
var shadow = system({
    boxShadow: {
      property: "boxShadow",
      scale: "shadows"
    },
    textShadow: {
      property: "textShadow",
      scale: "shadows"
    }
  }),
  index_esm_default9 = shadow;
function _extends2() {
  return _extends2 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
    return target;
  }, _extends2.apply(this, arguments);
}
var get4 = function (obj, key, def, p, undef) {
    for (key = key && key.split ? key.split(".") : [key], p = 0; p < key.length; p++) obj = obj ? obj[key[p]] : undef;
    return obj === undef ? def : obj;
  },
  defaultBreakpoints2 = [40, 52, 64].map(function (n) {
    return n + "em";
  }),
  defaultTheme2 = {
    space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
    fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72]
  },
  aliases2 = {
    bg: "backgroundColor",
    m: "margin",
    mt: "marginTop",
    mr: "marginRight",
    mb: "marginBottom",
    ml: "marginLeft",
    mx: "marginX",
    my: "marginY",
    p: "padding",
    pt: "paddingTop",
    pr: "paddingRight",
    pb: "paddingBottom",
    pl: "paddingLeft",
    px: "paddingX",
    py: "paddingY"
  },
  multiples2 = {
    marginX: ["marginLeft", "marginRight"],
    marginY: ["marginTop", "marginBottom"],
    paddingX: ["paddingLeft", "paddingRight"],
    paddingY: ["paddingTop", "paddingBottom"],
    size: ["width", "height"]
  },
  scales2 = {
    color: "colors",
    backgroundColor: "colors",
    borderColor: "colors",
    margin: "space",
    marginTop: "space",
    marginRight: "space",
    marginBottom: "space",
    marginLeft: "space",
    marginX: "space",
    marginY: "space",
    padding: "space",
    paddingTop: "space",
    paddingRight: "space",
    paddingBottom: "space",
    paddingLeft: "space",
    paddingX: "space",
    paddingY: "space",
    top: "space",
    right: "space",
    bottom: "space",
    left: "space",
    gridGap: "space",
    gridColumnGap: "space",
    gridRowGap: "space",
    gap: "space",
    columnGap: "space",
    rowGap: "space",
    fontFamily: "fonts",
    fontSize: "fontSizes",
    fontWeight: "fontWeights",
    lineHeight: "lineHeights",
    letterSpacing: "letterSpacings",
    border: "borders",
    borderTop: "borders",
    borderRight: "borders",
    borderBottom: "borders",
    borderLeft: "borders",
    borderWidth: "borderWidths",
    borderStyle: "borderStyles",
    borderRadius: "radii",
    borderTopRightRadius: "radii",
    borderTopLeftRadius: "radii",
    borderBottomRightRadius: "radii",
    borderBottomLeftRadius: "radii",
    borderTopWidth: "borderWidths",
    borderTopColor: "colors",
    borderTopStyle: "borderStyles",
    borderBottomWidth: "borderWidths",
    borderBottomColor: "colors",
    borderBottomStyle: "borderStyles",
    borderLeftWidth: "borderWidths",
    borderLeftColor: "colors",
    borderLeftStyle: "borderStyles",
    borderRightWidth: "borderWidths",
    borderRightColor: "colors",
    borderRightStyle: "borderStyles",
    outlineColor: "colors",
    boxShadow: "shadows",
    textShadow: "shadows",
    zIndex: "zIndices",
    width: "sizes",
    minWidth: "sizes",
    maxWidth: "sizes",
    height: "sizes",
    minHeight: "sizes",
    maxHeight: "sizes",
    flexBasis: "sizes",
    size: "sizes",
    fill: "colors",
    stroke: "colors"
  },
  positiveOrNegative2 = function (scale, value) {
    if (typeof value != "number" || value >= 0) return get4(scale, value, value);
    var absolute = Math.abs(value),
      n = get4(scale, absolute, absolute);
    return typeof n == "string" ? "-" + n : n * -1;
  },
  transforms2 = ["margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "top", "bottom", "left", "right"].reduce(function (acc, curr) {
    var _extends22;
    return _extends2({}, acc, (_extends22 = {}, _extends22[curr] = positiveOrNegative2, _extends22));
  }, {}),
  responsive2 = function (styles) {
    return function (theme) {
      var next2 = {},
        breakpoints = get4(theme, "breakpoints", defaultBreakpoints2),
        mediaQueries = [null].concat(breakpoints.map(function (n) {
          return "@media screen and (min-width: " + n + ")";
        }));
      for (var key in styles) {
        var value = typeof styles[key] == "function" ? styles[key](theme) : styles[key];
        if (value != null) {
          if (!Array.isArray(value)) {
            next2[key] = value;
            continue;
          }
          for (var i = 0; i < value.slice(0, mediaQueries.length).length; i++) {
            var media = mediaQueries[i];
            if (!media) {
              next2[key] = value[i];
              continue;
            }
            next2[media] = next2[media] || {}, value[i] != null && (next2[media][key] = value[i]);
          }
        }
      }
      return next2;
    };
  },
  css3 = function css4(args) {
    return function (props2) {
      props2 === void 0 && (props2 = {});
      var theme = _extends2({}, defaultTheme2, {}, props2.theme || props2),
        result = {},
        obj = typeof args == "function" ? args(theme) : args,
        styles = responsive2(obj)(theme);
      for (var key in styles) {
        var x = styles[key],
          val = typeof x == "function" ? x(theme) : x;
        if (key === "variant") {
          var variant3 = css4(get4(theme, val))(theme);
          result = _extends2({}, result, {}, variant3);
          continue;
        }
        if (val && typeof val == "object") {
          result[key] = css4(val)(theme);
          continue;
        }
        var prop = get4(aliases2, key, key),
          scaleName = get4(scales2, prop),
          scale = get4(theme, scaleName, get4(theme, prop, {})),
          transform = get4(transforms2, prop, get4),
          value = transform(scale, val, val);
        if (multiples2[prop]) for (var dirs = multiples2[prop], i = 0; i < dirs.length; i++) result[dirs[i]] = value;else result[prop] = value;
      }
      return result;
    };
  },
  index_esm_default10 = css3;
var variant = function (_ref) {
  var _config,
    scale = _ref.scale,
    _ref$prop = _ref.prop,
    prop = _ref$prop === void 0 ? "variant" : _ref$prop,
    _ref$variants = _ref.variants,
    variants = _ref$variants === void 0 ? {} : _ref$variants,
    key = _ref.key,
    sx;
  Object.keys(variants).length ? sx = function (value, scale2, props2) {
    return index_esm_default10(get2(scale2, value, null))(props2.theme);
  } : sx = function (value, scale2) {
    return get2(scale2, value, null);
  }, sx.scale = scale || key, sx.defaults = variants;
  var config9 = (_config = {}, _config[prop] = sx, _config),
    parser = createParser(config9);
  return parser;
};
var buttonStyle = variant({
    key: "buttons"
  }),
  textStyle = variant({
    key: "textStyles",
    prop: "textStyle"
  }),
  colorStyle = variant({
    key: "colorStyles",
    prop: "colors"
  });
var width = index_esm_default.width,
  height = index_esm_default.height,
  minWidth = index_esm_default.minWidth,
  minHeight = index_esm_default.minHeight,
  maxWidth = index_esm_default.maxWidth,
  maxHeight = index_esm_default.maxHeight,
  size = index_esm_default.size,
  verticalAlign = index_esm_default.verticalAlign,
  display = index_esm_default.display,
  overflow = index_esm_default.overflow,
  overflowX = index_esm_default.overflowX,
  overflowY = index_esm_default.overflowY,
  opacity = index_esm_default2.opacity,
  fontSize = index_esm_default3.fontSize,
  fontFamily = index_esm_default3.fontFamily,
  fontWeight = index_esm_default3.fontWeight,
  lineHeight = index_esm_default3.lineHeight,
  textAlign = index_esm_default3.textAlign,
  fontStyle = index_esm_default3.fontStyle,
  letterSpacing = index_esm_default3.letterSpacing,
  alignItems = index_esm_default4.alignItems,
  alignContent = index_esm_default4.alignContent,
  justifyItems = index_esm_default4.justifyItems,
  justifyContent = index_esm_default4.justifyContent,
  flexWrap = index_esm_default4.flexWrap,
  flexDirection = index_esm_default4.flexDirection,
  flex = index_esm_default4.flex,
  flexGrow = index_esm_default4.flexGrow,
  flexShrink = index_esm_default4.flexShrink,
  flexBasis = index_esm_default4.flexBasis,
  justifySelf = index_esm_default4.justifySelf,
  alignSelf = index_esm_default4.alignSelf,
  order = index_esm_default4.order,
  gridGap = index_esm_default5.gridGap,
  gridColumnGap = index_esm_default5.gridColumnGap,
  gridRowGap = index_esm_default5.gridRowGap,
  gridColumn = index_esm_default5.gridColumn,
  gridRow = index_esm_default5.gridRow,
  gridAutoFlow = index_esm_default5.gridAutoFlow,
  gridAutoColumns = index_esm_default5.gridAutoColumns,
  gridAutoRows = index_esm_default5.gridAutoRows,
  gridTemplateColumns = index_esm_default5.gridTemplateColumns,
  gridTemplateRows = index_esm_default5.gridTemplateRows,
  gridTemplateAreas = index_esm_default5.gridTemplateAreas,
  gridArea = index_esm_default5.gridArea,
  borderWidth = index_esm_default6.borderWidth,
  borderStyle = index_esm_default6.borderStyle,
  borderColor = index_esm_default6.borderColor,
  borderTop = index_esm_default6.borderTop,
  borderRight = index_esm_default6.borderRight,
  borderBottom = index_esm_default6.borderBottom,
  borderLeft = index_esm_default6.borderLeft,
  borderRadius = index_esm_default6.borderRadius,
  backgroundImage = index_esm_default7.backgroundImage,
  backgroundSize = index_esm_default7.backgroundSize,
  backgroundPosition = index_esm_default7.backgroundPosition,
  backgroundRepeat = index_esm_default7.backgroundRepeat,
  zIndex = index_esm_default8.zIndex,
  top = index_esm_default8.top,
  right = index_esm_default8.right,
  bottom = index_esm_default8.bottom,
  left = index_esm_default8.left;
var style = function (_ref) {
  var prop = _ref.prop,
    cssProperty = _ref.cssProperty,
    alias = _ref.alias,
    key = _ref.key,
    transformValue = _ref.transformValue,
    scale = _ref.scale,
    properties = _ref.properties,
    config9 = {};
  config9[prop] = createStyleFunction({
    properties,
    property: cssProperty || prop,
    scale: key,
    defaultScale: scale,
    transform: transformValue
  }), alias && (config9[alias] = config9[prop]);
  var parse2 = createParser(config9);
  return parse2;
};
var all = compose(space, typography, color, layout, flexbox, border, background, position2, grid, shadow, buttonStyle, textStyle, colorStyle),
  props = all.propNames,
  createShouldForwardProp = function (props2) {
    var regex = new RegExp("^(" + props2.join("|") + ")$");
    return emotion_memoize_esm_default(function (prop) {
      return is_prop_valid_esm_default(prop) && !regex.test(prop);
    });
  },
  index_esm_default11 = createShouldForwardProp(props);
export { CacheProvider, css as EmotionCSS, Global as StylingGlobals, ThemeContext, ThemeProvider, alignContent, alignItems, alignSelf, background, backgroundImage, backgroundPosition, backgroundRepeat, backgroundSize, border, borderBottom, borderColor, borderLeft, borderRadius, borderRight, borderStyle, borderTop, borderWidth, index_esm_default6 as borders, bottom, index_esm_default9 as boxShadow, buttonStyle, color, colorStyle, compose, emotion_cache_esm_default as createCache, createParser, createShouldForwardProp, createStyleFunction, css2 as css, display, flex, flexBasis, flexDirection, flexGrow, flexShrink, flexWrap, flexbox, fontFamily, fontSize, fontStyle, fontWeight, get2 as get, grid, gridArea, gridAutoColumns, gridAutoFlow, gridAutoRows, gridColumn, gridColumnGap, gridGap, gridRow, gridRowGap, gridTemplateAreas, gridTemplateColumns, gridTemplateRows, height, justifyContent, justifyItems, justifySelf, keyframes, layout, left, letterSpacing, lineHeight, margin, maxHeight, maxWidth, minHeight, minWidth, opacity, order, overflow, overflowX, overflowY, padding, position2 as position, props, right, shadow, size, space, style, emotion_styled_esm_default as styled, system, textAlign, index_esm_default9 as textShadow, textStyle, themeGet, top, typography, variant, verticalAlign, width, withTheme, zIndex };
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */